require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-ben-keller.json") })
        }
      }, "path---blog-author-ben-keller");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-ben-keller!./.cache/json/blog-author-ben-keller.json
// module id = 604
// module chunks = 231608221292675